import React from 'react';
import { PAGES } from '../../site/routes';
import { SITE } from '../../data/servers';
import { usePageSeo, Breadcrumbs, PageHeader, Section } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: "Conditions d'utilisation", to: PAGES.terms },
];

const Clause = ({ title, children }) => (
  <div>
    <h3 className="text-base sm:text-lg font-semibold text-white mb-1.5">{title}</h3>
    <div className="text-sm sm:text-base text-gray-400 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function TermsPage() {
  usePageSeo({
    title: "Conditions d'utilisation | AV Kamas",
    description: "Conditions d'utilisation d'AV Kamas : achat et vente de Kamas Dofus en dirhams au Maroc, commandes, paiements, responsabilités et droit applicable.",
    path: PAGES.terms,
    breadcrumbs: BREADCRUMBS,
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Légal"
        title={<>Conditions <span className="text-yellow-400">d'utilisation</span></>}
        intro="Dernière mise à jour : octobre 2026. En utilisant achatventekamas.com, vous acceptez les présentes conditions."
      />
      <Section className="pt-0 md:pt-0">
        <div className="max-w-3xl space-y-8">
          <Clause title="1. Objet">
            <p>
              AV Kamas (achatventekamas.com) est une plateforme indépendante d'achat et de vente de Kamas — la monnaie virtuelle des
              jeux Dofus, Dofus Rétro et Dofus Touch — destinée aux joueurs au Maroc. Les transactions sont réglées en dirhams (MAD).
            </p>
          </Clause>
          <Clause title="2. Compte utilisateur">
            <p>
              Vous pouvez passer commande en invité ou créer un compte. Vous vous engagez à fournir des informations exactes
              (email, téléphone, nom de personnage) et à garder vos identifiants confidentiels. Le service est réservé aux
              personnes de 18 ans et plus, ou aux mineurs avec l'accord d'un représentant légal.
            </p>
          </Clause>
          <Clause title="3. Commandes et paiement">
            <p>
              Les prix affichés sont en dirhams par million de Kamas et actualisés en temps réel. Après votre commande, vous
              réglez par virement vers un compte bancaire marocain et envoyez la preuve de paiement via le chat de commande.
              Une commande est traitée après vérification du paiement ; la livraison se fait en jeu au personnage indiqué.
            </p>
            <p>
              Pour la vente de Kamas, vous livrez la quantité convenue en jeu, puis le règlement en dirhams est effectué par
              virement vers votre RIB après vérification de la réception.
            </p>
          </Clause>
          <Clause title="4. Annulation et remboursement">
            <p>
              Vous pouvez annuler une commande tant qu'elle n'est pas validée par notre équipe. Si un paiement a été reçu pour
              une commande qui ne peut pas être livrée, un remboursement est effectué vers le même compte bancaire.
            </p>
          </Clause>
          <Clause title="5. Responsabilités">
            <p>
              AV Kamas est un service indépendant et n'est pas affilié à Ankama. L'échange de Kamas contre de l'argent réel
              peut enfreindre les conditions générales d'Ankama : vous utilisez le service en connaissance de ce risque, et
              AV Kamas ne saurait être tenu responsable d'éventuelles sanctions prises par l'éditeur du jeu (suspension ou
              fermeture de compte).
            </p>
            <p>
              Nous mettons en œuvre les moyens raisonnables pour sécuriser les échanges, sans garantie d'absence totale
              d'interruption ou d'erreur.
            </p>
          </Clause>
          <Clause title="6. Usages interdits">
            <p>
              Il est interdit d'utiliser le service pour des paiements frauduleux, des demandes de rétrofacturation abusives,
              la revente de Kamas d'origine illégale (comptes volés, bots), ou l'envoi de contenus illicites via le chat.
              Tout manquement peut entraîner l'annulation de la commande et la suspension du compte.
            </p>
          </Clause>
          <Clause title="7. Propriété intellectuelle">
            <p>
              Le contenu du site (textes, logo AV Kamas, mise en page) est protégé. Dofus, Dofus Rétro et Dofus Touch sont des
              marques d'Ankama. Aucune reproduction du site n'est autorisée sans accord écrit.
            </p>
          </Clause>
          <Clause title="8. Modification des conditions">
            <p>
              Ces conditions peuvent être mises à jour à tout moment ; la version en vigueur est celle publiée sur cette page,
              avec sa date de mise à jour. Les commandes en cours restent soumises aux conditions acceptées au moment de la
              commande.
            </p>
          </Clause>
          <Clause title="9. Droit applicable et contact">
            <p>
              Les présentes conditions sont soumises au droit marocain. Pour toute question :{' '}
              <a href={`mailto:${SITE.email}`} className="text-yellow-400 hover:underline">{SITE.email}</a> ou via le chat de
              votre commande.
            </p>
          </Clause>
        </div>
      </Section>
    </main>
  );
}
